/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfGetMenuByIdDto } from '../models/custom-result-of-get-menu-by-id-dto';
import { CustomResultOfGetProjectConfigurationDto } from '../models/custom-result-of-get-project-configuration-dto';
import { CustomResultOfListOfEndPointDto } from '../models/custom-result-of-list-of-end-point-dto';
import { CustomResultOfListOfGetAllMenusDto } from '../models/custom-result-of-list-of-get-all-menus-dto';
import { CustomResultOfListOfGetAllMenusListDto } from '../models/custom-result-of-list-of-get-all-menus-list-dto';
import { CustomResultOfListOfGetMenusByParentIdDto } from '../models/custom-result-of-list-of-get-menus-by-parent-id-dto';
import { documentCreateDocumentEndPoint } from '../fn/document/document-create-document-end-point';
import { DocumentCreateDocumentEndPoint$Params } from '../fn/document/document-create-document-end-point';
import { documentCreateDocumentMenu } from '../fn/document/document-create-document-menu';
import { DocumentCreateDocumentMenu$Params } from '../fn/document/document-create-document-menu';
import { documentCreateOrUpdateProjectConfiguration } from '../fn/document/document-create-or-update-project-configuration';
import { DocumentCreateOrUpdateProjectConfiguration$Params } from '../fn/document/document-create-or-update-project-configuration';
import { documentDeleteDocumentEndPoint } from '../fn/document/document-delete-document-end-point';
import { DocumentDeleteDocumentEndPoint$Params } from '../fn/document/document-delete-document-end-point';
import { documentDeleteDocumentMenu } from '../fn/document/document-delete-document-menu';
import { DocumentDeleteDocumentMenu$Params } from '../fn/document/document-delete-document-menu';
import { documentGetAllDocumentMenusList } from '../fn/document/document-get-all-document-menus-list';
import { DocumentGetAllDocumentMenusList$Params } from '../fn/document/document-get-all-document-menus-list';
import { documentGetDocumentEndPointByMenu } from '../fn/document/document-get-document-end-point-by-menu';
import { DocumentGetDocumentEndPointByMenu$Params } from '../fn/document/document-get-document-end-point-by-menu';
import { documentGetDocumentMenuById } from '../fn/document/document-get-document-menu-by-id';
import { DocumentGetDocumentMenuById$Params } from '../fn/document/document-get-document-menu-by-id';
import { documentGetDocumentMenus } from '../fn/document/document-get-document-menus';
import { DocumentGetDocumentMenus$Params } from '../fn/document/document-get-document-menus';
import { documentGetDocumentMenusByParentId } from '../fn/document/document-get-document-menus-by-parent-id';
import { DocumentGetDocumentMenusByParentId$Params } from '../fn/document/document-get-document-menus-by-parent-id';
import { documentGetProjectConfiguration } from '../fn/document/document-get-project-configuration';
import { DocumentGetProjectConfiguration$Params } from '../fn/document/document-get-project-configuration';
import { documentUpdateDocumentEndPoint } from '../fn/document/document-update-document-end-point';
import { DocumentUpdateDocumentEndPoint$Params } from '../fn/document/document-update-document-end-point';
import { documentUpdateDocumentMenu } from '../fn/document/document-update-document-menu';
import { DocumentUpdateDocumentMenu$Params } from '../fn/document/document-update-document-menu';

@Injectable({ providedIn: 'root' })
export class DocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentCreateDocumentMenu()` */
  static readonly DocumentCreateDocumentMenuPath = '/Document/CreateDocumentMenu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentCreateDocumentMenu()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentCreateDocumentMenu$Response(params: DocumentCreateDocumentMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return documentCreateDocumentMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentCreateDocumentMenu$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentCreateDocumentMenu(params: DocumentCreateDocumentMenu$Params, context?: HttpContext): Observable<CustomResult> {
    return this.documentCreateDocumentMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `documentCreateDocumentEndPoint()` */
  static readonly DocumentCreateDocumentEndPointPath = '/Document/CreateDocumentEndPoint';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentCreateDocumentEndPoint()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentCreateDocumentEndPoint$Response(params: DocumentCreateDocumentEndPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return documentCreateDocumentEndPoint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentCreateDocumentEndPoint$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentCreateDocumentEndPoint(params: DocumentCreateDocumentEndPoint$Params, context?: HttpContext): Observable<CustomResult> {
    return this.documentCreateDocumentEndPoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `documentUpdateDocumentMenu()` */
  static readonly DocumentUpdateDocumentMenuPath = '/Document/UpdateDocumentMenu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentUpdateDocumentMenu()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentUpdateDocumentMenu$Response(params: DocumentUpdateDocumentMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return documentUpdateDocumentMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentUpdateDocumentMenu$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentUpdateDocumentMenu(params: DocumentUpdateDocumentMenu$Params, context?: HttpContext): Observable<CustomResult> {
    return this.documentUpdateDocumentMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `documentUpdateDocumentEndPoint()` */
  static readonly DocumentUpdateDocumentEndPointPath = '/Document/UpdateDocumentEndPoint';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentUpdateDocumentEndPoint()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentUpdateDocumentEndPoint$Response(params: DocumentUpdateDocumentEndPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return documentUpdateDocumentEndPoint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentUpdateDocumentEndPoint$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentUpdateDocumentEndPoint(params: DocumentUpdateDocumentEndPoint$Params, context?: HttpContext): Observable<CustomResult> {
    return this.documentUpdateDocumentEndPoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `documentDeleteDocumentMenu()` */
  static readonly DocumentDeleteDocumentMenuPath = '/Document/DeleteDocumentMenu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentDeleteDocumentMenu()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentDeleteDocumentMenu$Response(params: DocumentDeleteDocumentMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return documentDeleteDocumentMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentDeleteDocumentMenu$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentDeleteDocumentMenu(params: DocumentDeleteDocumentMenu$Params, context?: HttpContext): Observable<CustomResult> {
    return this.documentDeleteDocumentMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `documentDeleteDocumentEndPoint()` */
  static readonly DocumentDeleteDocumentEndPointPath = '/Document/DeleteDocumentEndPoint';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentDeleteDocumentEndPoint()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentDeleteDocumentEndPoint$Response(params: DocumentDeleteDocumentEndPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return documentDeleteDocumentEndPoint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentDeleteDocumentEndPoint$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentDeleteDocumentEndPoint(params: DocumentDeleteDocumentEndPoint$Params, context?: HttpContext): Observable<CustomResult> {
    return this.documentDeleteDocumentEndPoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `documentGetDocumentEndPointByMenu()` */
  static readonly DocumentGetDocumentEndPointByMenuPath = '/Document/GetDocumentEndPointByMenu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetDocumentEndPointByMenu()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocumentEndPointByMenu$Response(params?: DocumentGetDocumentEndPointByMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfEndPointDto>> {
    return documentGetDocumentEndPointByMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetDocumentEndPointByMenu$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocumentEndPointByMenu(params?: DocumentGetDocumentEndPointByMenu$Params, context?: HttpContext): Observable<CustomResultOfListOfEndPointDto> {
    return this.documentGetDocumentEndPointByMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfEndPointDto>): CustomResultOfListOfEndPointDto => r.body)
    );
  }

  /** Path part for operation `documentGetDocumentMenus()` */
  static readonly DocumentGetDocumentMenusPath = '/Document/GetDocumentMenus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetDocumentMenus()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocumentMenus$Response(params?: DocumentGetDocumentMenus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetAllMenusDto>> {
    return documentGetDocumentMenus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetDocumentMenus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocumentMenus(params?: DocumentGetDocumentMenus$Params, context?: HttpContext): Observable<CustomResultOfListOfGetAllMenusDto> {
    return this.documentGetDocumentMenus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetAllMenusDto>): CustomResultOfListOfGetAllMenusDto => r.body)
    );
  }

  /** Path part for operation `documentGetAllDocumentMenusList()` */
  static readonly DocumentGetAllDocumentMenusListPath = '/Document/GetAllDocumentMenusList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetAllDocumentMenusList()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetAllDocumentMenusList$Response(params?: DocumentGetAllDocumentMenusList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetAllMenusListDto>> {
    return documentGetAllDocumentMenusList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetAllDocumentMenusList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetAllDocumentMenusList(params?: DocumentGetAllDocumentMenusList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetAllMenusListDto> {
    return this.documentGetAllDocumentMenusList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetAllMenusListDto>): CustomResultOfListOfGetAllMenusListDto => r.body)
    );
  }

  /** Path part for operation `documentGetDocumentMenuById()` */
  static readonly DocumentGetDocumentMenuByIdPath = '/Document/GetDocumentMenuById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetDocumentMenuById()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocumentMenuById$Response(params?: DocumentGetDocumentMenuById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetMenuByIdDto>> {
    return documentGetDocumentMenuById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetDocumentMenuById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocumentMenuById(params?: DocumentGetDocumentMenuById$Params, context?: HttpContext): Observable<CustomResultOfGetMenuByIdDto> {
    return this.documentGetDocumentMenuById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetMenuByIdDto>): CustomResultOfGetMenuByIdDto => r.body)
    );
  }

  /** Path part for operation `documentGetDocumentMenusByParentId()` */
  static readonly DocumentGetDocumentMenusByParentIdPath = '/Document/GetDocumentMenusByParentId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetDocumentMenusByParentId()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocumentMenusByParentId$Response(params?: DocumentGetDocumentMenusByParentId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetMenusByParentIdDto>> {
    return documentGetDocumentMenusByParentId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetDocumentMenusByParentId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocumentMenusByParentId(params?: DocumentGetDocumentMenusByParentId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetMenusByParentIdDto> {
    return this.documentGetDocumentMenusByParentId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetMenusByParentIdDto>): CustomResultOfListOfGetMenusByParentIdDto => r.body)
    );
  }

  /** Path part for operation `documentCreateOrUpdateProjectConfiguration()` */
  static readonly DocumentCreateOrUpdateProjectConfigurationPath = '/Document/CreateOrUpdateProjectConfiguration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentCreateOrUpdateProjectConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentCreateOrUpdateProjectConfiguration$Response(params: DocumentCreateOrUpdateProjectConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return documentCreateOrUpdateProjectConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentCreateOrUpdateProjectConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentCreateOrUpdateProjectConfiguration(params: DocumentCreateOrUpdateProjectConfiguration$Params, context?: HttpContext): Observable<CustomResult> {
    return this.documentCreateOrUpdateProjectConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `documentGetProjectConfiguration()` */
  static readonly DocumentGetProjectConfigurationPath = '/Document/GetProjectConfiguration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetProjectConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetProjectConfiguration$Response(params?: DocumentGetProjectConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetProjectConfigurationDto>> {
    return documentGetProjectConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetProjectConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetProjectConfiguration(params?: DocumentGetProjectConfiguration$Params, context?: HttpContext): Observable<CustomResultOfGetProjectConfigurationDto> {
    return this.documentGetProjectConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetProjectConfigurationDto>): CustomResultOfGetProjectConfigurationDto => r.body)
    );
  }

}
